import { ChevronRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { TableCell, TableRow } from '@/components/ui/table';

/** A file-list section heading that folds its rows away. The rows stay siblings
 * in the table body — nesting them under this would be invalid table markup, so
 * the caller renders them and gates on the same `open`. */
export default function FileSectionToggleRow({
  label,
  count,
  open,
  onToggle,
  cellClassName,
}: {
  label: string;
  count: number;
  open: boolean;
  onToggle: () => void;
  cellClassName?: string;
}) {
  return (
    <TableRow className="hover:bg-transparent border-b-0">
      <TableCell colSpan={4} className={cellClassName}>
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={open}
          className="flex w-full items-center gap-1.5 text-left transition-colors hover:text-foreground"
        >
          <ChevronRight
            className={cn(
              'h-3.5 w-3.5 shrink-0 transition-transform duration-fast',
              open && 'rotate-90'
            )}
          />
          {label}
          <span className="text-xs font-normal text-muted-foreground">
            ({count})
          </span>
        </button>
      </TableCell>
    </TableRow>
  );
}
